import { graphql } from 'gatsby';
import React from 'react';
import Layout from '../components/Global/Layout/Layout';
import ProductSnippet from '../components/Global/ProductSnippet/ProductSnippet';
import { v4 as uuidv4 } from 'uuid';
import { Col, Row } from 'react-bootstrap';
import styles from '../components/Page-CSS/productCategoriesTemplate.module.css';
import SEO from '../components/Global/SEO';

const Collections = ({ data }) => {
	const {
		description: { fullDescription },
		title,
		metaImage: { fluid: { src } }
	} = data.allContentfulCollectionPage.nodes[0];
	return (
		<Layout>
			<SEO title="Our Collections" description={fullDescription} image={src} />
			<Row style={{ margin: '2rem 0rem' }}>
				<Col xs={12}>
					<Row
						className={styles.descriptionHolder}
						style={{ borderBottom: '1px solid rgba(128, 128, 128, 0.76)', marginBottom: '1rem' }}
					>
						<Col xs={12} sm={6} className={styles.description}>
							<h1>{title}</h1>
							<p>{fullDescription}</p>
						</Col>
					</Row>
				</Col>
				{data.allShopifyCollection.nodes.map((product) => (
					<ProductSnippet
						src={product.image.localFile.childImageSharp.fluid}
						title={product.title}
						price=""
						handle={`${product.handle}`}
						key={uuidv4()}
						padding="1rem"
					/>
				))}
			</Row>
		</Layout>
	);
};

export default Collections;

export const query = graphql`
	query {
		allShopifyCollection {
			nodes {
				handle
				title
				image {
					localFile {
						childImageSharp {
							fluid {
								...GatsbyImageSharpFluid
							}
						}
					}
				}
			}
		}
		allContentfulCollectionPage {
			nodes {
				metaImage {
					fluid {
						src
					}
				}
				description {
					fullDescription: description
				}
				title
			}
		}
	}
`;
